// This file is auto-generated by @hey-api/openapi-ts

export type ApiCondition = {
    type: 'location' | 'address_list' | 'is_special_flood_hazard_area' | 'is_in_named_list' | 'always_true';
    valid_locations: Array<ApiLocation>;
    address_list: Array<(string)>;
    list_name: string | null;
};

export type type = 'location' | 'address_list' | 'is_special_flood_hazard_area' | 'is_in_named_list' | 'always_true';

export const type = {
    LOCATION: 'location',
    ADDRESS_LIST: 'address_list',
    IS_SPECIAL_FLOOD_HAZARD_AREA: 'is_special_flood_hazard_area',
    IS_IN_NAMED_LIST: 'is_in_named_list',
    ALWAYS_TRUE: 'always_true'
} as const;

export type ApiDeductibleFilter = {
    reasoning: string | null;
    condition: ApiCondition;
    deductible_percentage_0_to_100: number | null;
    deductible_flat_dollar_amount: number | null;
    per_occurrence_limit: number | null;
    not_covered: boolean | null;
    is_tbd?: boolean | null;
};

export type ApiDeductibleForPeril = {
    reasoning_steps: Array<(string)>;
    relevant_document: string;
    relevant_page_numbers: Array<(number)>;
    filter_fallthrough: Array<ApiDeductibleFilter> | null;
    excerpt: string;
};

export type ApiLocation = {
    state: string;
    county: string | null;
};

export type ApiNamedList = {
    notes: string;
    list_name: string;
    locations: Array<ApiLocation>;
    excluded_locations: Array<ApiLocation>;
};

export type ApiNamedListWithoutLocations = {
    notes: string;
    list_name: string;
    document: string;
    page_number: number;
    peril_types: Array<('earthquake' | 'flood' | 'named_storm')>;
};

export type ApiNamedLists = {
    lists: Array<ApiNamedList>;
};

export type ApiNamedListsWithoutLocations = {
    lists: Array<ApiNamedListWithoutLocations>;
};

export type AddSavedFilterRequest = {
    url: string;
    nickname: string;
    is_default: boolean;
};

export type AdditionalAssigneeInfo = {
    assignees: {
        [key: string]: (string);
    };
};

export type Address = {
    address_id: string;
    is_deleted?: boolean | null;
    default_sort_key?: string | null;
    private_computed_values: RawAddress;
    private_original_values: {
        [key: string]: (string | null);
    };
    private_overrides: {
        [key: string]: (string | number | null);
    };
    private_flags: {
        [key: string]: Array<('missing_coverage_headers' | 'date_parsing_error' | 'number_parsing_error' | 'large_number_warning' | 'suspicious_year_warning' | 'year_out_of_range_warning' | 'general_mismatch' | 'low_confidence' | 'medium_confidence' | 'cooking_class_guess' | 'non_property_insurance_value' | 'unrecognized_central_alarm_value' | 'low_sprinkler_percentage' | 'unrecognized_sprinkler_value' | 'zip_parsing_error' | 'blank_tiv_value' | 'non_ascii_removed' | 'address_corrected_by_geocoding' | 'geocoding_failed' | 'location_number_mismatch' | 'low_aop_deductible' | 'autofilled_aop_deductible' | 'year_defaulted_to_year_built' | 'approximate_geocoding' | UnknownCoverageColumnFlag | UnknownInsuranceSubjectFlag | AddressCorrectedByModel | AddressFlaggedByGeocoding | CoverageComputedFromColumnSum)>;
    };
};

export type AddressCorrectedByModel = {
    flag_id: "address_corrected_by_llm_parse";
    original: string;
};

export type AddressFlaggedByGeocoding = {
    flag_id: "address_flagged_by_geocoding";
    geocoded: string | null;
};

export type Analysis = {
    inter_code_issues: Array<(string)>;
    codes: Array<CodeAnalysis>;
};

export type AnalyzeCodesRequest = {
    codes: Array<(string)>;
};

export type AnalyzeCodesResponse = {
    analysis: Analysis;
};

export type AttachmentInfo = {
    attachments: Array<SrcAcropolisAcropolisTypesAttachment>;
};

export type BodyAcropolisIngestEmailAcropolisIngestEmailPost = {
    message: (Blob | File);
    to: string;
    from_email: string;
};

export type BodyAcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPost = {
    files: Array<((Blob | File))>;
};

export type BodyAdonisUploadFilesAdonisUploadFilesPost = {
    files: Array<((Blob | File))>;
};

export type BodyLoginLoginPost = {
    grant_type?: string | null;
    username: string;
    password: string;
    scope?: string;
    client_id?: string | null;
    client_secret?: string | null;
};

export type BodyNdProcessInspectionReportNdProcessInspectionReportPost = {
    file: (Blob | File);
    metadata: string;
};

export type BulkEditRequest = {
    report_id: string;
    field: string;
    instructions: string;
};

export type BulkEditResponse = {
    before: Array<Address>;
    after: Array<Address>;
};

export type BusinessClassification = {
    major_industry_index: number;
    minor_industry_index: number;
    company_description: string;
    llm_reasoning?: string | null;
};

export type CensusTractRisks = {
    census_tract: string;
    num_addresses: number;
    hurricane_risk: number;
    tornado_risk: number;
    earthquake_risk: number;
    wildfire_risk: number;
    winter_storm_risk: number;
};

export type CodeAnalysis = {
    code: string;
    title: string;
    description: string;
    notes: string;
    questions: Array<CodeQuestion>;
};

export type CodeQuestion = {
    question: string;
    affirmative_outcome: string;
    negative_outcome: string;
};

export type CommercialConversationResponse = {
    all_messages: Array<Message>;
};

export type CommercialConversationtInput = {
    report_id: string;
    messages: Array<Message>;
};

export type CommercialReport = {
    report_id: string;
    appetite_score: number;
    naics_info: NaicsInfo;
    sovs: Array<Sov>;
    env_risks: Array<CensusTractRisks>;
    loss_run: LossRunInfo;
    company_info: CompanyInfo;
    layer_info: Array<Layer>;
    risk_details: RiskDetails;
    deductible_info: DeductibleInfo | null;
    due_date: string;
    business_classification?: BusinessClassification | null;
    ofac_result?: OfacResult | null;
    news_info?: Array<NewsInfo> | null;
    policy_questions?: {
    [key: string]: Array<PolicyQuestion>;
} | null;
    additional_files_used?: Array<(string)> | null;
    loss_control_reports?: Array<LossControlReport> | null;
    generated_on_version?: string | null;
    attachment_info?: AttachmentInfo | null;
    referral_text?: ReferralText | null;
};

export type CommericalReportMetadata = {
    report_id: string;
    lob: string;
    appetite_score: number;
    naics_info: NaicsInfo;
    company_info: CompanyInfo;
    risk_details: RiskDetails;
    business_classification?: BusinessClassification | null;
    sov_metadata: SovMetadata;
};

export type CompanyInfo = {
    private_computed_values: RawCompanyInfo;
    private_original_values: {
        [key: string]: (Array<(string)> | string | null);
    };
    private_overrides: {
        [key: string]: (string | Array<(string)> | null);
    };
    private_flags: {
        [key: string]: Array<('low_confidence' | 'medium_confidence' | YearIncorporatedDerivedFromSearch)>;
    };
};

export type ComputedLossRunByYear = {
    policy_year: string;
    description_of_losses: string;
    calc_mode: 'historical' | 'as_if' | null;
    source_details: SourceDetails;
    source: "computed_from_claims";
    claims: Array<(ParsedLoss | UserGeneratedLoss)>;
};

export type ContactFormRequest = {
    name: string;
    email: string;
    company_name: string;
    message: string;
};

export type CoverageComputedFromColumnSum = {
    flag_id: "coverage_computed_from_column_sum";
    columns: Array<(string)>;
};

export type DeductibleInfo = {
    named_lists: ApiNamedListsWithoutLocations;
    named_lists_content: ApiNamedLists;
    earthquake_specific_deductible?: ApiDeductibleForPeril | null;
    flood_specific_deductible?: ApiDeductibleForPeril | null;
    named_storm_specific_deductible?: ApiDeductibleForPeril | null;
    all_others_specific_deductible?: ApiDeductibleForPeril | null;
    failure_explanation?: string | null;
    flag_reasons?: Array<(string)>;
    requires_sfha_data?: boolean | null;
};

export type DeleteAdditionalFilesRequest = {
    files: Array<(string)>;
};

export type DeleteAdditionalFilesResponse = {
    files: Array<(string)>;
};

export type DeleteSavedFilterRequest = {
    id: string;
};

export type DownloadAdditionalFileRequest = {
    report_id: string;
    file: string;
};

export type DownloadLossRunRequest = {
    loss_run_years: Array<UserGeneratedLossRunByYear>;
};

export type DownloadProcessedReportRequest = {
    output_filename: string;
};

export type DownloadSovRequest = {
    report_id: string;
    format: string;
};

export type Envelope = {
    to: string;
    from: string;
};

export type FindPossibleCodesRequest = {
    prodecure_description: string;
};

export type FindPossibleCodesResponse = {
    possible_codes: Array<PossibleCode>;
};

export type GenerateListingPdfRequest = {
    listing_type_ids: {
        [key: string]: (string);
    };
    is_renewal: boolean;
};

export type GenerateStrPdfRequest = {
    urls: Array<(string)>;
    is_renewal: boolean;
};

export type GenerateUnderwritingPdfRequest = {
    report_id: string;
    html_content: string;
};

export type GoogleSheetMetadata = {
    title: string;
};

export type HttpValidationError = {
    detail?: Array<ValidationError>;
};

export type Hazard = {
    name: string;
    explanation: string;
    severity: number;
    severity_level: string;
    id: string;
};

export type Headers = {
    message_id: string;
    subject: string;
};

export type HumanReviewInfo = {
    review_by_section: {
        [key: string]: Array<HumanReviewQuestion>;
    };
};

export type HumanReviewQuestion = {
    question_id: string;
    status: string;
    warning_message: string | null;
    last_updated_ts: string | null;
    last_updated_user_id: string | null;
};

export type IncomingMail = {
    envelope: Envelope;
    headers: Headers;
    plain?: string | null;
    attachments?: Array<SrcWaivoSendEmailAttachment>;
};

export type Layer = {
    starting_point: number;
    range: number;
    target: number | null;
    rated: number | null;
};

export type ListAdditionalFilesResponse = {
    files: Array<(string)>;
};

export type ListBatchesResponse = {
    batches: Array<RenewalBatch>;
};

export type ListReportsResponse = {
    reports: Array<ReportMetadataResponse>;
};

export type ListSavedFiltersResponse = {
    filters: Array<SavedFilter>;
};

export type ListUserResponse = {
    current_user: User;
    all_company_users: Array<User>;
};

export type LoadAddressesForMapResponse = {
    addresses: Array<SpatialKeyAddress>;
};

export type LogEventRequest = {
    event_name: string;
    event_properties: {
        [key: string]: (string | number);
    };
};

export type LoginResponse = {
    access_token: string;
    token_type: string;
    client_id: string;
};

export type LossControlAnswer = {
    short_answer: string;
    long_answer: string;
};

export type LossControlReport = {
    entity_name?: string | null;
    filename: string;
    fields: {
        [key: string]: (LossControlAnswer | null);
    };
};

export type LossRunInfo = {
    loss_runs_by_year: {
        [key: string]: Array<(UserGeneratedLossRunByYear | ComputedLossRunByYear | ParsedLossRunByYear)>;
    };
    enabled_by_source: {
        [key: string]: SourceDetailInfo;
    };
};

export type MappingInfo = {
    original_col_name: string;
    confidence: number;
};

export type Message = {
    is_user_message: boolean;
    is_visible: boolean;
    content: string;
    original: string;
};

export type NaicsInfo = {
    code_type?: 'sic' | 'naics';
    code: string;
    description: string;
};

export type code_type = 'sic' | 'naics';

export const code_type = {
    SIC: 'sic',
    NAICS: 'naics'
} as const;

export type NewsInfo = {
    description: string;
    quote: string;
    url: string;
};

export type OfacResult = {
    sanctioned_due_to: Array<(string)>;
};

export type ParsedLoss = {
    policy_year: string;
    date_of_loss: string;
    address: string | null;
    claim_id: string | null;
    loss_id: string | null;
    status: string;
    description: string | null;
    ground_up_loss: number | null;
    deductible: number | null;
    net_incurred: number | null;
    is_cat_event: boolean | null;
    claim_type: 'historical' | 'as_if' | null;
    source: "parsed";
    source_details: SourceDetails;
    overrides: {
        [key: string]: (string);
    };
    flags: {
        [key: string]: Array<("could_not_parse")>;
    };
    original_values: {
        [key: string]: (string);
    };
};

export type ParsedLossRunByYear = {
    policy_year: string;
    description_of_losses: string;
    calc_mode: 'historical' | 'as_if' | null;
    source_details: SourceDetails;
    source: "parsed_year";
    open_claims: number;
    closed_claims: number;
    ground_up_loss: number | null;
    net_incurred: number | null;
    carrier: string | null;
    flags: {
        [key: string]: Array<("could_not_parse")>;
    };
    original_values: {
        [key: string]: (string);
    };
    overrides: {
        [key: string]: (string);
    };
};

export type PolicyQuestion = {
    question: string;
    short_answer: string;
    long_answer: string;
    question_id: string;
    excerpt: string;
    confidence: string;
    page_location: string;
};

export type PossibleCode = {
    code: string;
    reasoning: string;
};

export type ProcessInspectionReportResponse = {
    policy_number: string;
    output_filename: string;
    hazards: Array<Hazard>;
    is_flagged: boolean;
    non_renewal: boolean;
    rec_letter: boolean;
    itv_flag: boolean;
    itv_percentage: number | null;
    betterview_roof_score: number | null;
    betterview_square_footage: number | null;
    policy_coverage_a: number | null;
    inspection_coverage_a: number | null;
    policy_square_footage: number | null;
    inspection_square_footage: number | null;
    total_hazard_score: number;
};

export type RawAddress = {
    street_address: string;
    tiv: number;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    county?: string | null;
    country?: string | null;
    country_scheme?: string | null;
    country_code?: string | null;
    year_built?: string | null;
    sprinkler?: string | null;
    smoke_detector?: string | null;
    fire_protection_class?: string | null;
    building_value?: string | null;
    bpp_value?: string | null;
    business_interruption_value?: string | null;
    tenant_betterments_value?: string | null;
    signs_value?: string | null;
    glass_value?: string | null;
    number_of_stories?: string | null;
    construction_code_type?: string | null;
    construction_code?: string | null;
    construction_description?: string | null;
    occupancy_code_type?: string | null;
    occupancy_code?: string | null;
    occupancy_description?: string | null;
    occupancy_description_other?: string | null;
    location_name?: string | null;
    location_description?: string | null;
    lat?: string | null;
    long?: string | null;
    tract?: string | null;
    number_of_buildings?: string | null;
    square_footage?: string | null;
    plan_irregularity?: string | null;
    soft_story?: string | null;
    vertical_irregularity?: string | null;
    eq_cladding_type?: string | null;
    short_column?: string | null;
    urm_chimney?: string | null;
    urm_partition?: string | null;
    ornamentation?: string | null;
    cripple_walls?: string | null;
    frame_bolted_down?: string | null;
    anchoring?: string | null;
    urm_retrofit?: string | null;
    structural_upgrade?: string | null;
    engineered_foundation?: string | null;
    equipment_eq_bracing?: string | null;
    eq_construction_quality?: string | null;
    equipment_support_maintenance?: string | null;
    pounding?: string | null;
    base_isolation?: string | null;
    sprinkler_type?: string | null;
    eqsl_susceptibility?: string | null;
    ws_construction_quality?: string | null;
    roof_geometry?: string | null;
    roof_anchor?: string | null;
    roof_equipment_hurricane_bracing?: string | null;
    commercial_appurtenant_structures?: string | null;
    roof_covering?: string | null;
    roof_age_or_condition?: string | null;
    ws_cladding_type?: string | null;
    roof_sheathing_attachment?: string | null;
    frame_foundation_connection?: string | null;
    residential_appurtenant_structures?: string | null;
    ground_level_equipment?: string | null;
    opening_protection?: string | null;
    flashing_and_coping_quality?: string | null;
    floor_type?: string | null;
    flood_missiles?: string | null;
    flood_protection?: string | null;
    basement_protection?: string | null;
    vertical_exposure_distribution?: string | null;
    bi_preparedness?: string | null;
    bi_redundancy?: string | null;
    flood_zone?: string | null;
    named_storm_deductible?: number | null;
    named_storm_agg_limit?: number | null;
    named_storm_occ_limit?: number | null;
    flood_deductible?: number | null;
    flood_agg_limit?: number | null;
    flood_occ_limit?: number | null;
    eq_deductible?: number | null;
    eq_agg_limit?: number | null;
    eq_occ_limit?: number | null;
    aop_deductible?: number | null;
    aop_agg_limit?: number | null;
    aop_occ_limit?: number | null;
    wiring_year?: string | null;
    plumbing_year?: string | null;
    roofing_year?: string | null;
    heating_year?: string | null;
    fire_alarm_type?: string | null;
    burglar_alarm_type?: string | null;
    premises_number?: string | null;
    building_number?: string | null;
    building_description?: string | null;
    cooking_class?: string | null;
    geocoded_street_address?: string | null;
    geocoded_city?: string | null;
    geocoded_county?: string | null;
    geocoded_state?: string | null;
    geocoded_zip?: string | null;
    geocoded_country?: string | null;
};

export type RawCompanyInfo = {
    company_name: string;
    company_description: string;
    company_industry: string;
    effective_date: string;
    broker_name: string;
    broker_email?: string | null;
    broker_agent_name?: string | null;
    named_insured?: string | null;
    additional_named_insureds?: Array<(string)> | null;
    dba?: string | null;
    entity_type?: string | null;
    expiration_date?: string | null;
    business_description?: string | null;
    years_in_business?: string | null;
    company_address?: string | null;
    company_city?: string | null;
    company_state?: string | null;
    company_zip?: string | null;
    target_premium?: string | null;
    quote_by_date?: string | null;
    is_renewal_business?: string | null;
    year_of_incorporation?: string | null;
    premier_extension?: string | null;
};

export type ReferralText = {
    text: string | null;
};

export type RenewalBatch = {
    created_at_ts: string;
    num_files: number;
    num_processed: number;
    processed_files_folder_name: string | null;
};

export type ReportMetadataResponse = {
    report_id: string;
    lob: string;
    report_metadata: CommericalReportMetadata;
    created_at_ts: string;
    modified_at_ts: string;
    assignee: string | null;
    status: 'in_flight' | 'bound' | 'declined' | 'quoted' | 'lost' | 'reviewed';
    workflow_metadata: WorkflowMetadata | null;
    additional_assignees: AdditionalAssigneeInfo | null;
};

export type status = 'in_flight' | 'bound' | 'declined' | 'quoted' | 'lost' | 'reviewed';

export const status = {
    IN_FLIGHT: 'in_flight',
    BOUND: 'bound',
    DECLINED: 'declined',
    QUOTED: 'quoted',
    LOST: 'lost',
    REVIEWED: 'reviewed'
} as const;

export type ReportResponse = {
    report_id: string;
    lob: string;
    email_subject: string;
    report_json: CommercialReport;
    created_at_ts: string;
    modified_at_ts: string;
    human_review_info: HumanReviewInfo;
    assignee: string | null;
    status: 'in_flight' | 'bound' | 'declined' | 'quoted' | 'lost' | 'reviewed';
    workflow_metadata: WorkflowMetadata | null;
    additional_assignees: AdditionalAssigneeInfo | null;
};

export type RiskDetail = {
    title: string;
    description: string;
};

export type RiskDetails = {
    positive: Array<RiskDetail>;
    negative: Array<RiskDetail>;
    disqualifying: Array<RiskDetail>;
};

export type Sov = {
    sov_id: string;
    addresses: Array<Address>;
    is_enabled: boolean;
    filename: string;
    all_document_headers?: Array<(string)> | null;
    column_mappings?: {
    [key: string]: MappingInfo;
} | null;
    column_overrides?: {
    [key: string]: (string);
} | null;
};

export type SavedFilter = {
    id: string;
    url: string;
    nickname: string;
    is_default: boolean;
};

export type SearchAddressRequest = {
    lob?: string | null;
    raw_query: string | null;
    term_query: Array<TermSearch> | null;
};

export type SearchAddressResponse = {
    by_report: {
        [key: string]: Array<Address>;
    };
    term_query: Array<TermSearch> | null;
};

export type SendInfoToGoogleSheetsRequest = {
    report_id: string;
    google_sheet_url: string;
    send_addresses: boolean | null;
    send_general_input: boolean | null;
};

export type SourceDetailInfo = {
    source_details: SourceDetails;
    enabled: boolean;
};

export type SourceDetails = {
    filename: string;
    sheet_name: string | null;
    data_type: 'claim' | 'summary';
    calc_mode: 'historical' | 'as_if' | null;
    carrier: string | null;
};

export type data_type = 'claim' | 'summary';

export const data_type = {
    CLAIM: 'claim',
    SUMMARY: 'summary'
} as const;

export type SovMetadata = {
    num_locations: number;
    total_tiv: number;
};

export type SpatialKeyAddress = {
    'Policy Number': string;
    'Named Insured': string;
    'Effective Date': string;
    'Expiration Date': string;
    'Location #'?: string | null;
    'Bulding#'?: string | null;
    'Street 1'?: string | null;
    'Street 2'?: string | null;
    City?: string | null;
    State?: string | null;
    Zip?: string | null;
    County?: string | null;
    BLDG?: number | null;
    BPP?: number | null;
    TIB?: number | null;
    BUSIN?: number | null;
    'Total TIV'?: number | null;
    EQPBK?: string | null;
    TRIA?: string | null;
    LNLawOrdA?: number | null;
    LNLawOrdBC?: number | null;
    LNLawOrd?: number | null;
    Valuation?: string | null;
    Coinsurance?: string | null;
    PTY_WIND_INCL_Y_N?: string | null;
    WIND_DEDUCTIBLE_BASIS?: string | null;
    WIND_DEDUCTIBLE_AMOUNT?: string | null;
    WIND_DEDUCTIBLE_PERCENTAGE?: string | null;
    AOP_DEDUCTIBLE_BASIS?: string | null;
    AOP_DEDUCTIBLE_PERCENTAGE?: string | null;
    AOP_DEDUCTIBLE_AMOUNT?: string | null;
    CP_DEDUCTIBLE_AMOUNT?: string | null;
    CP_DEDUCTIBLE_TYPE?: string | null;
    'Latitude(SK)'?: number | null;
    'Longitude(SK)'?: number | null;
    'Geocoding Accuracy'?: string | null;
};

export type SupahubSsoResponse = {
    jwt_payload: string;
};

export type TermSearch = {
    street?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
};

export type UnknownCoverageColumnFlag = {
    flag_id: "unkonwn_coverage_column";
    columns: Array<(string)>;
};

export type UnknownInsuranceSubjectFlag = {
    flag_id: "non_property_insurance_value_v2";
    subjects: Array<(string)>;
};

export type UpdateAddressRequest = {
    report_id: string;
    addresses: Array<Address>;
};

export type UpdateAddressResponse = {
    addresses: Array<Address>;
};

export type UpdateAsignee = {
    new_assignee: string | null;
};

export type UpdateAssigneeRequest = {
    rater_url: string;
    user_id: string | null;
};

export type UpdateReportRequest = {
    report_id: string;
    update_assignee: UpdateAsignee | null;
    update_status: UpdateStatus | null;
    update_additional_assignees: AdditionalAssigneeInfo | null;
    update_sovs: Array<Sov> | null;
    update_loss_runs_info: LossRunInfo | null;
    update_human_review_question: HumanReviewQuestion | null;
    update_company_info: CompanyInfo | null;
    update_attachment_info: AttachmentInfo | null;
    update_referral_text: ReferralText | null;
    rerun_report: boolean | null;
};

export type UpdateReportResponse = {
    report: ReportResponse;
    did_write_to_bsp_repo: boolean;
};

export type UpdateSavedFilterRequest = {
    id: string;
    is_default: boolean;
    nickname: string;
};

export type UpdateStatus = {
    new_status: 'in_flight' | 'bound' | 'declined' | 'quoted' | 'lost' | 'reviewed';
};

export type new_status = 'in_flight' | 'bound' | 'declined' | 'quoted' | 'lost' | 'reviewed';

export const new_status = {
    IN_FLIGHT: 'in_flight',
    BOUND: 'bound',
    DECLINED: 'declined',
    QUOTED: 'quoted',
    LOST: 'lost',
    REVIEWED: 'reviewed'
} as const;

export type UpdateStatusRequest = {
    rater_url: string;
    status: 'in_flight' | 'bound' | 'declined' | 'quoted' | 'lost' | 'reviewed';
};

export type UploadAdditionalFilesResponse = {
    files: Array<(string)>;
};

export type User = {
    id: string;
    email: string;
    client_id: string;
    lobs: Array<(string)>;
    full_name?: string | null;
};

export type UserGeneratedLoss = {
    policy_year: string;
    date_of_loss: string;
    address: string | null;
    claim_id: string | null;
    loss_id: string | null;
    status: string;
    description: string | null;
    ground_up_loss: number | null;
    deductible: number | null;
    net_incurred: number | null;
    is_cat_event: boolean | null;
    claim_type: 'historical' | 'as_if' | null;
    source: "user_generated";
    source_details: SourceDetails;
};

export type UserGeneratedLossRunByYear = {
    policy_year: string;
    description_of_losses: string;
    calc_mode: 'historical' | 'as_if' | null;
    source_details: SourceDetails;
    open_claims: number;
    closed_claims: number;
    ground_up_loss: number | null;
    net_incurred: number | null;
    source: "user_generated";
};

export type ValidateUrlRequest = {
    url: string;
};

export type ValidateUrlResponse = {
    data: GoogleSheetMetadata | null;
    error: 'invalid_url' | 'no_permission' | 'unknown_error' | null;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
};

export type WorkflowMetadata = {
    bluesky_rater_url: string | null;
    bluesky_client_folder_url: string | null;
    bluesky_submissions_folder_url?: string | null;
    bluesky_aggregation_folder_url?: string | null;
    do_not_process?: boolean | null;
};

export type YearIncorporatedDerivedFromSearch = {
    flag_id: "year_incorporated_derived_from_search";
    source: string;
};

export type SrcAcropolisAcropolisTypesAttachment = {
    name: string;
    from_email: boolean;
    original_mapping: 'sov_spreadsheet' | 'acord_app' | 'loss_run' | 'none' | 'screenshot';
    manual_mapping: 'sov_spreadsheet' | 'acord_app' | 'loss_run' | 'none' | 'screenshot' | null;
};

export type original_mapping = 'sov_spreadsheet' | 'acord_app' | 'loss_run' | 'none' | 'screenshot';

export const original_mapping = {
    SOV_SPREADSHEET: 'sov_spreadsheet',
    ACORD_APP: 'acord_app',
    LOSS_RUN: 'loss_run',
    NONE: 'none',
    SCREENSHOT: 'screenshot'
} as const;

export type SrcWaivoSendEmailAttachment = {
    file_name: string;
    content_type: string;
    content: string | null;
};

export type HealthcheckHealthcheckGetResponse = unknown;

export type LoginLoginPostData = {
    formData: BodyLoginLoginPost;
};

export type LoginLoginPostResponse = LoginResponse;

export type ListUsersListUsersPostResponse = ListUserResponse;

export type SupahubSsoSupahubSsoPostResponse = SupahubSsoResponse;

export type LogEventLogEventPostData = {
    requestBody: LogEventRequest;
};

export type LogEventLogEventPostResponse = unknown;

export type ContactFormContactFormPostData = {
    requestBody: ContactFormRequest;
};

export type ContactFormContactFormPostResponse = unknown;

export type ListingPdfListingPdfPostData = {
    requestBody: GenerateListingPdfRequest;
};

export type ListingPdfListingPdfPostResponse = unknown;

export type ListingJsonListingJsonPostData = {
    requestBody: GenerateListingPdfRequest;
};

export type ListingJsonListingJsonPostResponse = unknown;

export type GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostData = {
    requestBody: GenerateStrPdfRequest;
};

export type GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostResponse = unknown;

export type GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostData = {
    requestBody: GenerateStrPdfRequest;
};

export type GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostResponse = unknown;

export type ContinueCommercialConversationContinueCommercialConversationPostData = {
    requestBody: CommercialConversationtInput;
};

export type ContinueCommercialConversationContinueCommercialConversationPostResponse = CommercialConversationResponse;

export type AcropolisIngestEmailAcropolisIngestEmailPostData = {
    formData: BodyAcropolisIngestEmailAcropolisIngestEmailPost;
};

export type AcropolisIngestEmailAcropolisIngestEmailPostResponse = unknown;

export type BsrUpdateStatusBsrUpdateStatusPostData = {
    requestBody: UpdateStatusRequest;
};

export type BsrUpdateStatusBsrUpdateStatusPostResponse = unknown;

export type BsrUpdateAssigneeBsrUpdateAssigneePostData = {
    requestBody: UpdateAssigneeRequest;
};

export type BsrUpdateAssigneeBsrUpdateAssigneePostResponse = unknown;

export type AcropolisListReportsAcropolisListReportsGetResponse = ListReportsResponse;

export type AcropolisListReportAcropolisListReportReportIdGetData = {
    reportId: string;
};

export type AcropolisListReportAcropolisListReportReportIdGetResponse = ReportResponse;

export type AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostData = {
    requestBody: SendInfoToGoogleSheetsRequest;
};

export type AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostResponse = unknown;

export type AcropolisValidateUrlAcropolisValidateUrlPostData = {
    requestBody: ValidateUrlRequest;
};

export type AcropolisValidateUrlAcropolisValidateUrlPostResponse = ValidateUrlResponse;

export type AcropolisDownloadSovAcropolisDownloadSovPostData = {
    requestBody: DownloadSovRequest;
};

export type AcropolisDownloadSovAcropolisDownloadSovPostResponse = unknown;

export type AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostData = {
    requestBody: GenerateUnderwritingPdfRequest;
};

export type AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostResponse = unknown;

export type AcropolisDownloadLossRunAcropolisDownloadLossRunPostData = {
    requestBody: DownloadLossRunRequest;
};

export type AcropolisDownloadLossRunAcropolisDownloadLossRunPostResponse = unknown;

export type AcropolisUpdateReportAcropolisUpdateReportPostData = {
    requestBody: UpdateReportRequest;
};

export type AcropolisUpdateReportAcropolisUpdateReportPostResponse = UpdateReportResponse;

export type AcropolisUpdateAddressAcropolisUpdateAddressPostData = {
    requestBody: UpdateAddressRequest;
};

export type AcropolisUpdateAddressAcropolisUpdateAddressPostResponse = UpdateAddressResponse;

export type AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostData = {
    requestBody: SearchAddressRequest;
};

export type AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostResponse = SearchAddressResponse;

export type AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostData = {
    reportId: string;
};

export type AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostResponse = ListAdditionalFilesResponse;

export type AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostData = {
    reportId: string;
    requestBody: DeleteAdditionalFilesRequest;
};

export type AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostResponse = DeleteAdditionalFilesResponse;

export type AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostData = {
    classificationForAllFiles?: 'sov_spreadsheet' | 'acord_app' | 'loss_run' | 'none' | 'screenshot' | null;
    formData: BodyAcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPost;
    reportId: string;
};

export type AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostResponse = UploadAdditionalFilesResponse;

export type AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostData = {
    requestBody: DownloadAdditionalFileRequest;
};

export type AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostResponse = unknown;

export type GenerateBulkEditAcropolisGenerateBulkEditPostData = {
    requestBody: BulkEditRequest;
};

export type GenerateBulkEditAcropolisGenerateBulkEditPostResponse = BulkEditResponse;

export type DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetData = {
    filename: string;
    reportId: string;
};

export type DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetResponse = unknown;

export type AdonisUploadFilesAdonisUploadFilesPostData = {
    formData: BodyAdonisUploadFilesAdonisUploadFilesPost;
};

export type AdonisUploadFilesAdonisUploadFilesPostResponse = unknown;

export type RestartBatchAdonisRestartBatchPostData = {
    epoch: string;
};

export type RestartBatchAdonisRestartBatchPostResponse = unknown;

export type DeleteBatchAdonisDeleteBatchPostData = {
    epoch: string;
};

export type DeleteBatchAdonisDeleteBatchPostResponse = unknown;

export type AdonisListBatchesAdonisListBatchesGetResponse = ListBatchesResponse;

export type AdonisDownloadPdfsAdonisDownloadPdfsGetData = {
    folderName: string;
};

export type AdonisDownloadPdfsAdonisDownloadPdfsGetResponse = unknown;

export type NdProcessInspectionReportNdProcessInspectionReportPostData = {
    formData: BodyNdProcessInspectionReportNdProcessInspectionReportPost;
};

export type NdProcessInspectionReportNdProcessInspectionReportPostResponse = ProcessInspectionReportResponse;

export type NdDownloadProcessedReportNdDownloadProcessedReportPostData = {
    requestBody: DownloadProcessedReportRequest;
};

export type NdDownloadProcessedReportNdDownloadProcessedReportPostResponse = string;

export type WaivoParseRentalHistoryWaivoParseRentalHistoryPostData = {
    requestBody: IncomingMail;
};

export type WaivoParseRentalHistoryWaivoParseRentalHistoryPostResponse = {
    [key: string]: (string);
};

export type DentaAnalyzeCodesDentaAnalyzeCodesPostData = {
    requestBody: AnalyzeCodesRequest;
};

export type DentaAnalyzeCodesDentaAnalyzeCodesPostResponse = AnalyzeCodesResponse;

export type DentaFindPossibleCodesDentaFindPossibleCodesPostData = {
    requestBody: FindPossibleCodesRequest;
};

export type DentaFindPossibleCodesDentaFindPossibleCodesPostResponse = FindPossibleCodesResponse;

export type DevDumpCoroutinesDevDumpCoroutinesPostResponse = {
    [key: string]: (string);
};

export type CheckRunningJobsDevCheckRunningJobsPostResponse = {
    [key: string]: Array<(string)>;
};

export type AcropolisListSavedFiltersAcropolisListSavedFiltersPostResponse = ListSavedFiltersResponse;

export type AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostData = {
    requestBody: DeleteSavedFilterRequest;
};

export type AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostResponse = ListSavedFiltersResponse;

export type AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostData = {
    requestBody: UpdateSavedFilterRequest;
};

export type AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostResponse = ListSavedFiltersResponse;

export type AcropolisAddSavedFilterAcropolisAddSavedFilterPostData = {
    requestBody: AddSavedFilterRequest;
};

export type AcropolisAddSavedFilterAcropolisAddSavedFilterPostResponse = ListSavedFiltersResponse;

export type AcropolisLoadAddressesForMapAcropolisLoadAddressesForMapPostResponse = LoadAddressesForMapResponse;

export type $OpenApiTs = {
    '/healthcheck': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/login': {
        post: {
            req: LoginLoginPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: LoginResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/list_users': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                200: ListUserResponse;
            };
        };
    };
    '/supahub_sso': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                200: SupahubSsoResponse;
            };
        };
    };
    '/log_event': {
        post: {
            req: LogEventLogEventPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/contact_form': {
        post: {
            req: ContactFormContactFormPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/listing_pdf': {
        post: {
            req: ListingPdfListingPdfPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/listing_json': {
        post: {
            req: ListingJsonListingJsonPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/generate_str_pdf_from_urls': {
        post: {
            req: GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/generate_str_json_from_urls': {
        post: {
            req: GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/continue_commercial_conversation': {
        post: {
            req: ContinueCommercialConversationContinueCommercialConversationPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: CommercialConversationResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/ingest_email': {
        post: {
            req: AcropolisIngestEmailAcropolisIngestEmailPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/bsr/update_status': {
        post: {
            req: BsrUpdateStatusBsrUpdateStatusPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/bsr/update_assignee': {
        post: {
            req: BsrUpdateAssigneeBsrUpdateAssigneePostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/list_reports': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: ListReportsResponse;
            };
        };
    };
    '/acropolis/list_report/{report_id}': {
        get: {
            req: AcropolisListReportAcropolisListReportReportIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: ReportResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/send_info_to_google_sheets': {
        post: {
            req: AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/validate_url': {
        post: {
            req: AcropolisValidateUrlAcropolisValidateUrlPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ValidateUrlResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/download_sov': {
        post: {
            req: AcropolisDownloadSovAcropolisDownloadSovPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/generate_underwriting_pdf': {
        post: {
            req: AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/download_loss_run': {
        post: {
            req: AcropolisDownloadLossRunAcropolisDownloadLossRunPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/update_report': {
        post: {
            req: AcropolisUpdateReportAcropolisUpdateReportPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UpdateReportResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/update_address': {
        post: {
            req: AcropolisUpdateAddressAcropolisUpdateAddressPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UpdateAddressResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/search_report_addresses': {
        post: {
            req: AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: SearchAddressResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/list_additional_files/{report_id}': {
        post: {
            req: AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ListAdditionalFilesResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/delete_additional_files/{report_id}': {
        post: {
            req: AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: DeleteAdditionalFilesResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/upload_additional_files': {
        post: {
            req: AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UploadAdditionalFilesResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/download_additional_file': {
        post: {
            req: AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/generate_bulk_edit': {
        post: {
            req: GenerateBulkEditAcropolisGenerateBulkEditPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkEditResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/download_report_file/{report_id}/{filename}': {
        get: {
            req: DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/adonis/upload_files': {
        post: {
            req: AdonisUploadFilesAdonisUploadFilesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/adonis/restart_batch': {
        post: {
            req: RestartBatchAdonisRestartBatchPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/adonis/delete_batch': {
        post: {
            req: DeleteBatchAdonisDeleteBatchPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/adonis/list_batches': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: ListBatchesResponse;
            };
        };
    };
    '/adonis/download_pdfs': {
        get: {
            req: AdonisDownloadPdfsAdonisDownloadPdfsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/nd/process_inspection_report': {
        post: {
            req: NdProcessInspectionReportNdProcessInspectionReportPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ProcessInspectionReportResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/nd/download_processed_report': {
        post: {
            req: NdDownloadProcessedReportNdDownloadProcessedReportPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: string;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/waivo/parse_rental_history': {
        post: {
            req: WaivoParseRentalHistoryWaivoParseRentalHistoryPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: {
                    [key: string]: (string);
                };
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/denta/analyze_codes': {
        post: {
            req: DentaAnalyzeCodesDentaAnalyzeCodesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: AnalyzeCodesResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/denta/find_possible_codes': {
        post: {
            req: DentaFindPossibleCodesDentaFindPossibleCodesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FindPossibleCodesResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/dev/dump_coroutines': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                200: {
                    [key: string]: (string);
                };
            };
        };
    };
    '/dev/check_running_jobs': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                200: {
                    [key: string]: Array<(string)>;
                };
            };
        };
    };
    '/acropolis/list_saved_filters': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                200: ListSavedFiltersResponse;
            };
        };
    };
    '/acropolis/delete_saved_filter': {
        post: {
            req: AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ListSavedFiltersResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/update_saved_filter': {
        post: {
            req: AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ListSavedFiltersResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/add_saved_filter': {
        post: {
            req: AcropolisAddSavedFilterAcropolisAddSavedFilterPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ListSavedFiltersResponse;
                /**
                 * Validation Error
                 */
                422: HttpValidationError;
            };
        };
    };
    '/acropolis/load_addresses_for_map': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                200: LoadAddressesForMapResponse;
            };
        };
    };
};